import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ClassNames } from '@emotion/react';
import { memo, } from 'react';
import { CSSTransition } from 'react-transition-group';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { transitionSides } from './constants';
import { actionPanelStyles } from './styles';
const initialOpacity = 0.25;
const initialSlideOffset = styleUtils.rem(-300);
const ActionPanelTransition = ({ actionPanelClassName, children, fade, show, side, }) => (_jsx(ClassNames, { children: ({ css: classNames, cx, }) => {
        /**
         * `cx` combines styles from different `className`s. `cx` is used here because
         * this component receives user styles `actionPanelClassName` in the form of a
         * `className` and not a `css` string
         */
        const hasTransition = Boolean(transitionSides[side]);
        // Pass only [] and not [''] as it messes up the transition.
        const transitionProperties = (fade
            ? [
                side,
                'opacity',
            ]
            : [
                side,
            ]);
        const transitionStyles = classNames `${styleUtils.transition(transitionProperties)}`;
        // User styles are applied on top of the default ActionPanel styles
        const mergedStyles = cx(classNames `${actionPanelStyles}`, actionPanelClassName);
        const enterStyles = classNames `
        ${side}: ${initialSlideOffset};
        ${fade && `opacity: ${initialOpacity}`};
      `;
        const enterActiveStyles = cx(mergedStyles, classNames `
          ${transitionStyles};
          ${fade && 'opacity: 1'};
        `);
        return (
        /**
         * `enterDone` state is used to apply the normal ActionPanel styles when
         * done transitioning. This state still occurs when the CSSTransition
         * doesn't enter or exit (no transition)
         * In case the ActionPanel initially renders showing, the enter transition
         * needs to occur so that the `enterDone` styles are applied
         */
        _jsx(CSSTransition, Object.assign({ appear: true, classNames: {
                appear: enterStyles,
                appearActive: enterActiveStyles,
                enter: enterStyles,
                enterActive: enterActiveStyles,
                enterDone: mergedStyles,
                exit: cx(mergedStyles, classNames `${fade && 'opacity: 1'};`),
                exitActive: classNames `
              ${transitionStyles};
              ${side}: ${initialSlideOffset};
              ${fade && `opacity: ${initialOpacity}`};
            `,
            }, enter: hasTransition, exit: hasTransition, in: show, timeout: parseInt(theme.durationDefault, 10), unmountOnExit: true }, { children: children })));
    } }));
const MemoizedActionPanelTransition = memo(ActionPanelTransition);
export { MemoizedActionPanelTransition as ActionPanelTransition };
// MC-1068 Temporary hack for Storybook.
export default ActionPanelTransition;
